@use 'mixins';
@use 'variables';
@use 'fonts';
@use 'toaster';

:root {
  --color-brand: #{variables.$blue-primary};
  --color-danger: #{variables.$red4};
}

* {
  margin: 0;
  padding: 0;

  outline: none;
  accent-color: variables.$blue-primary;
}

*,
*::before,
*::after {
  box-sizing: inherit;
}

*,
button,
input,
select,
textarea {
  color: variables.$black-primary;
  font-family: variables.$global-font-family;
}

html {
  box-sizing: border-box;

  font-size: 62.5%; // 1rem = 10px, 10px/16px = 62.5%
}

a {
  text-decoration: none;
}

button {
  border: none;

  background-color: variables.$white;
  cursor: pointer;
}

body {
  height: 100vh;
  overflow-y: hidden;
}
